import React from "react";

import 'styles/animations.scss';

function HistoryLoadingScreen(props) {
  if (props.isLoaded === undefined)
    throw new SyntaxError('missing required property of HistoryLoadingScreen: isLoaded');
  else if (props.isLoaded === false)
    return (<p style={{fontSize: '3.4em'}} className='glowing'>Loading...</p>);
  else
    return null;
}

export default HistoryLoadingScreen;